import type { AnswerWidgets } from '@openx/components-core/lib/AiChat/answerWidgets.ts';
import { Markdown } from '@openx/components-core/lib/Markdown/Markdown.tsx';
import { renderOpenXAgentAnswerWidget } from '../../AnswerWidgets/openXAgentAnswerWidgets.tsx';
import { MESSAGE_FONT_SIZE } from '../utils/consts.ts';

type OpenXAgentMarkdownProps = {
  content: string;
  widgets?: AnswerWidgets | undefined;
};

export const OpenXAgentMarkdown = ({ content, widgets }: OpenXAgentMarkdownProps) => (
  <Markdown
    content={content}
    fontSize={MESSAGE_FONT_SIZE}
    widgets={widgets}
    renderWidget={renderOpenXAgentAnswerWidget}
  />
);
